import React, { Component } from "react";
import axios from "axios";
import * as appConst from "../../../Common/constants";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import downloadImage from "../../../Images/download.jpg"
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import fileDownload from 'js-file-download';

class Extract extends Component {
  constructor(props) {
    super(props);
    this.state =
    {
      inputFiles: null,
      outputFiles: null
    };
  }

  componentDidMount() {
    this.LoadFiles();
  }

  LoadFiles() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/file?mode=AZIN&account=EBuy"
      )
      .then(response => {
        this.setState({
          inputFiles: response.data.InputFiles,
          outputFiles: response.data.OutputFiles
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <h3 align="center">Amazon India - Order Extract</h3>
        <div className="container-fluid border">
          <div className="row p-1 border">
            <input type="file" onChange={this.fileChangedHandler} />
            <button
              onClick={this.uploadHandler}
              className="btn btn-primary btn-sm"
            >
              Upload
            </button>
          </div>
          <div className="row p-1 border text-center">
            <button
              onClick={this.processClick}
              className="btn btn-warning btn-lg"
            >
              Process
            </button>
          </div>
          <div className="row p-1 border"  >
            <div className="ag-theme-blue" style={{ width: "520px", height: "450px" }} >
              <div>
                <button
                  onClick={this.onDeleteInputClick}
                  className="btn btn-primary btn-sm mb-2 mr-2"
                >
                  Clear Input Files
                </button>
              </div>
              <AgGridReact
                rowData={this.state.inputFiles}
                pagination={true}
                onGridReady={params => (this.gridApi = params.api)}
              //paginationAutoPageSize={true}
              >
                <AgGridColumn
                  field="Name"
                  headerName="Input File"
                  width={500}
                  sortable
                  resizable
                  filter
                />
              </AgGridReact></div>&nbsp;
            <div className="ag-theme-blue" style={{ width: "600px" }} >
              <div>
                <button
                  onClick={this.onDeleteOutputClick}
                  className="btn btn-primary btn-sm mb-2 mr-2"
                >
                  Clear Output Files
                </button>
              </div>
              <AgGridReact
                rowData={this.state.outputFiles}
                pagination={true}
                onGridReady={params => (this.gridApi = params.api)}
              >
                <AgGridColumn
                  width={40}
                  cellRendererFramework={this.renderDownloadButton}
                />
                <AgGridColumn
                  field="Name"
                  headerName="Output File"
                  width={500}
                  sortable
                  resizable
                  filter
                />

              </AgGridReact></div>
          </div>
        </div>
      </div >
    );
  }

  renderDownloadButton = params => {
    return (
      <p>
        <a
          onClick={this.onDownloadClick}
        >
          <img src={downloadImage} name={params.data.Name} width="20px" height="20px" />
        </a>
      </p>
    );
  };

  onDownloadClick = e => {
    var name = e.target.getAttribute("name");
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/outputfile?mode=AZIN&account=EBuy&fileName=" + name
      )
      .then(res => {
        fileDownload(res.data.Content, res.data.FileName)
      });
  };

  fileChangedHandler = event => {
    this.setState({ selectedFile: event.target.files[0] })
  }

  uploadHandler = () => {
    if (this.state.selectedFile !== null) {
      const formData = new FormData();
      formData.append(
        'file',
        this.state.selectedFile,
        this.state.selectedFile.name,
      )

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/file?mode=AZIN&account=EBuy",
          formData
        )
        .then(res => {
          this.setState({ selectedFile: null });
          this.LoadFiles();
        });
    }
  }

  processClick = () => {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/file/process?mode=AZIN&account=EBuy"
      )
      .then(res => {
        this.LoadFiles();
      });
  }

  onDeleteInputClick = () => {
    this.DeleteFiles("input");
  }

  onDeleteOutputClick = () => {
    this.DeleteFiles("output");
  }

  DeleteFiles(type) {
    var res = window.confirm("Are you sure to delete ?");
    if (res == true) {
      axios
        .delete(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/file?mode=AZIN&account=EBuy&type=" + type
        )
        .then(res => {
          this.LoadFiles();
        });
    }
  }

  getHeight() {
    var hgt = window.innerHeight - 275;
    return { height: hgt + "px" };
  }
}

export default Extract;
